module.exports = __webpack_public_path__ + "static/img/TIDAL.d3c82e0f.png";